import { createContext, useContext } from "react"
import { AuthorProps, HymnProps } from "../types";

export type GlobalContent = {
  currentTimer: number;
  totalTimer: number;
  hymnId: number;
  hymn: HymnProps | undefined,
  hymns: HymnProps[],
  favorites: HymnProps[],
  authors: Record<number, AuthorProps>,
  textSearch: string,
  startDownload: boolean,
  setTextSearch: (text: string) => void,
  setCurrentTimer: (timer: number) => void
  setTotalTimer: (timer: number) => void
  setHymnId: (id: number) => void,
  setHymn: (hymns: HymnProps) => void,
  setHymns: (hymns: HymnProps[]) => void,
  setFavorites: (hymns: HymnProps[]) => void,
  setAuthors: (authors: Record<number, AuthorProps>) => void
  setStartDownload: (start: boolean) => void
}

export const GlobalContext = createContext<GlobalContent>({
  currentTimer: 0,
  totalTimer: 0,
  hymnId: 0,
  hymn: undefined,
  hymns: [],
  favorites: [],
  authors: {},
  textSearch: '',
  startDownload: false,
  setTextSearch: () => {},
  setCurrentTimer: () => {},
  setTotalTimer: () => {},
  setHymnId: () => {},
  setHymn: () => {},
  setHymns: () => {},
  setFavorites: () => {},
  setAuthors: () => {},
  setStartDownload: () => {},
});

export const useGlobalContext = () => useContext(GlobalContext);
